import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
import TbodySeparator from '../TbodySeparator';
import Td, { Wrapper as TdWrapper } from '../Td';
import Tr from '../Tr';
import { footerDropContext } from './DndContext';
export const Footer = styled.tbody `
  ${TdWrapper} {
    border-top: 2px solid ${({ theme }) => theme.colors.grey30_1};
  }
`;
const TbodyFooter = () => {
    const footer = React.useContext(footerDropContext);
    return (_jsxs(_Fragment, { children: [_jsx(Footer, { ref: footer, children: _jsx(Tr, { children: _jsx(Td, { type: 'sub' }) }) }), _jsx(TbodySeparator, {})] }));
};
export default TbodyFooter;
